const columns = [
    {key: 'selected', label: '선택', width: 50, hAlign: 'center'},
    {key: 'index', label: '번호', width: 80, hAlign: 'center'},
    {key: 'project_code', label: '프로젝트 코드', width: 220, tdClass: 'text-left td-truncate'},
    {key: 'period', label: '분기2', width: 120, hAlign: 'center'},
    {key: 'campaign_name', label: '캠페인명',width: 220, tdClass: 'text-left td-truncate'}, // width가 없으면 남은 공간 차지
    {key: 'client', label: '고객사', width: 120, hAlign: 'center', tdClass: 'td-truncate'},
    {key: 'target_end_date', label: '마감일', width: 120, hAlign: 'center'},
    {key: 'excel_download', label: '엑셀 다운로드', hAlign: 'center'},
];

export {
    columns
};
